import { render } from "./HeroiconsOutlineBookmarkAlt.vue?vue&type=template&id=461b9f5a"
const script = {}

import exportComponent from "/Users/nekenaratafitaharitsimba/Work/HULSIA/PROJECTS/smilemood-v2/smilemood-v2-backend/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineBookmarkAlt.vue"]])

export default __exports__